import { z } from 'zod';
export const Ipv4Schema = z.ipv4();
export const WorldNetworkSchema = z.object({
  address: Ipv4Schema,
  gateway: Ipv4Schema,
  dns: Ipv4Schema,
  prefix: z.literal(24).default(24),
});
export type WorldNetwork = z.infer<typeof WorldNetworkSchema>;
export const ChangeWorldIpSchema = z.object({ address: Ipv4Schema.optional() }).strict();
export function worldIpSettings(env: Record<string, string | undefined>) {
  if (!env.MCPANEL_WORLD_IP_RANGE) return undefined;
  const parts = env.MCPANEL_WORLD_IP_RANGE.split('-');
  if (parts.length !== 2) throw new Error('MCPANEL_WORLD_IP_RANGE は IPv4-IPv4 で指定してください');
  const [start, end] = parts.map((part) => Ipv4Schema.parse(part));
  const gateway = Ipv4Schema.parse(env.MCPANEL_WORLD_GATEWAY);
  const dns = Ipv4Schema.parse(env.MCPANEL_WORLD_DNS);
  const subnet = start!.split('.').slice(0, 3).join('.');
  const first = Number(start!.split('.').at(-1));
  const last = Number(end!.split('.').at(-1));
  if (
    end!.split('.').slice(0, 3).join('.') !== subnet ||
    first < 1 ||
    last > 254 ||
    first > last ||
    gateway.split('.').slice(0, 3).join('.') !== subnet ||
    ['0', '255'].includes(gateway.split('.').at(-1)!)
  ) {
    throw new Error('固定 IP の範囲と gateway は同じ /24 の有効なホストアドレスにしてください');
  }
  return { addresses: Array.from({ length: last - first + 1 }, (_, i) => subnet + '.' + (first + i)), gateway, dns };
}
export function selectWorldIp(addresses: string[], used: Iterable<string>, requested?: string) {
  const occupied = new Set(used);
  if (requested && !addresses.includes(requested)) throw new Error('指定の IP は割り当て範囲外です');
  const address = (requested ? [requested] : addresses).find((ip) => !occupied.has(ip));
  if (!address) throw new Error('割り当て可能な固定 IP がありません');
  return address;
}
export function ipconfig0(network?: WorldNetwork) {
  return network ? 'ip=' + network.address + '/24,gw=' + network.gateway : 'ip=dhcp';
}
